export let severityLevels;
(function (severityLevels) {
  severityLevels["maintenance"] = "MAINTENANCE";
  severityLevels["outage"] = "OUTAGE";
  severityLevels["debug"] = "DEBUG";
  severityLevels["critSit"] = "CRITSIT";
})(severityLevels || (severityLevels = {}));
export const fireAlarmTypes = {
  [severityLevels.maintenance]: 'info',
  [severityLevels.outage]: 'warning',
  [severityLevels.debug]: 'tip',
  [severityLevels.critSit]: 'critSit'
};